const counter = function(){
  this.timerArr = {}

  this.countFormat = function(val, fixed, comma){
    if(val > 100 && !!comma){
      const str = val.toString();
      const strArr = [];
      const strSplit = str.split("");
      while (strSplit.length > 3) {
        strArr.unshift(strSplit.splice(strSplit.length - 3, 3).join(""));
      }
      strArr.unshift(strSplit.join(""));
      return strArr
    }else if(val.toString().indexOf('.') !== -1){
      return val.toFixed(fixed)
    }else{
      return val
    }
  }

  this.start = function(el, key, duration){
    this.countWarp = el
    this.count = parseFloat(this.countWarp.getAttribute('data-count-start'))
    this.total = parseFloat(this.countWarp.getAttribute('data-count-total'))
    this.multiple = parseFloat(this.countWarp.getAttribute('data-multiple'))
    this.duration = parseFloat(this.countWarp.getAttribute('data-duration'))
    this.noComma = this.countWarp.getAttribute('data-noComma')

    this.timer = setInterval(() => {
      this.count += this.multiple
      if(this.count>=this.total){
        this.countWarp.innerHTML = this.countFormat(this.total, this.multiple.toString().length-this.multiple.toString().indexOf('.'), this.noComma);
        clearInterval(this.timer);
      }else{
        this.countWarp.innerHTML = this.countFormat(this.count, this.multiple.toString().length-1-this.multiple.toString().indexOf('.'), this.noComma);
      }
    }, !!this.duration ? this.duration : duration)
    this.timerArr[key] = this.timer
  }

  this.reset = function(el, key){
    this.countWarp = el
    this.count = parseFloat(this.countWarp.getAttribute('data-count-start'))
    this.countWarp.innerHTML = this.count;
    clearInterval(this.timerArr[key])
  }

}



export default counter